module.exports = __webpack_public_path__ + "img/shenhezhong.886f4066.png";